import { useNavigate, useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../application/config/config';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Fetch from "../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";
import sleep from "sleep-promise";

function Form() {
  const profileFilter = chooseProfileFilter();
  const { id } = useParams();
  const dispatch = useDispatch();
  const formSession = useSelector(state => state.session);
  const [form, setForm] = useState();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('');
  const [permission, setPermission] = useState([]);
  const [formContent, setFormContent] = useState(<>Carregando...</>);

  const endpointBackend = config.endpoints.backend;
  const sessionSelector = useSelector((state) => { return state.session });
  const path = '/governanceroom/departmentsmanagers/';
  const paths = {
    endpointSave: endpointBackend + 'governanceroom/departmentsmanagers/save',
    endpointPermissionSave: endpointBackend + 'core/users/updatepermissions',
    endpointGetById: endpointBackend + 'governanceroom/departmentsmanagers/getById',
    endpointGetAppProfileById: `${endpointBackend}core/applicationsprofiles/getById`,
    urlGoBack: path + 'list',
    pathView: path + 'view'
  }

  const hiddenValuesToForm = {};

  if (profileFilter.core_application_instance_id) {
    hiddenValuesToForm.application_instance_id = profileFilter.core_application_instance_id;
  }

  useEffect(() => {
    dispatch({
      type: "UPDATE_SESSION",
      key: "current_user_permission",
      value: permission,
    });
  }, [permission]);

  const handleSubmit = async (fields, values, loadData) => {
    const finalPermission = formSession["current_user_permission"];
    const finalValues = { ...values, permissions: finalPermission };
    await Fetch.put(paths.endpointSave, finalValues);
  };

  const getForm = (values) => {

    const labels = {
      labelTitleAdd: "Novo Gestor de Departamentos",
      labelTitleEdit: "Editar Gestor de Departamentos",
      labelTitleView: 'Visualizar Gestor de Departamentos',
    }

    const form = {
      validateOnChange: true,
      hiddenValues: hiddenValuesToForm,
      handleSubmit,
      afterSubmit: () => {
        navigate(paths.urlGoBack);
      },
      fields: [
        {
          name: 'photo',
          type: 'file',
          label: 'Foto',
          uploadPath: '/departmentsmanagers/photos/',
          extensionAccept: '.jpeg,.jpg,.png',
          limitFileSize: 5,
          validations: {
            required: false
          },
          columnSize: 6
        },
        !profileFilter.governance_room_client_city_id && {
          name: 'governance_room_client_city_id',
          type: 'select',
          label: 'Município',
          options: [],
          optionsEndpoint: {
            endpoint: endpointBackend + 'governanceroom/clientscities/getall',
            label: 'company_name',
            value: 'id',
            params: {
              filter: {
                ...profileFilter
              }
            }
          },
          handleChange: async (element, field, values) => {
            values.governance_room_department_id = '';
            values.governance_room_secretariat_id = '';
            let form = getForm(values);
            setForm(form);
            setFormContent(<></>);
            await sleep(1);
            setFormContent(
              <CustomFormContainer
                form={form}
                content={<CustomForm form={form} />}
              />)
          },
          validations: {
            required: true
          },
          columnSize: 12
        },
        !profileFilter.governance_room_secretariat_id && {
          name: 'governance_room_secretariat_id',
          type: 'select',
          label: 'Secretaria',
          options: [],
          optionsEndpoint: {
            endpoint: endpointBackend + 'governanceroom/secretariats/getall',
            label: 'title_secretariat',
            value: 'id',
            params: {
              filter: {
                ...profileFilter,
                governance_room_client_city_id: profileFilter.governance_room_client_city_id ? profileFilter.governance_room_client_city_id : values.governance_room_client_city_id
              }
            }
          },
          handleChange: async (element, field, values) => {
            let form = getForm(values);
            setForm(form);
            setFormContent(<></>);
            await sleep(1);
            setFormContent(
              <CustomFormContainer
                form={form}
                content={<CustomForm form={form} />}
              />)
          },
          validations: {
            required: true
          },
          columnSize: 12
        },
        {
          name: 'governance_room_department_id',
          type: 'select',
          label: 'Departamento',
          options: [],
          optionsEndpoint: {
            endpoint: endpointBackend + 'governanceroom/departments/getall',
            label: 'title_department',
            value: 'id',
            params: {
              filter: {
                ...profileFilter,
                governance_room_client_city_id: profileFilter.governance_room_client_city_id ? profileFilter.governance_room_client_city_id : values.governance_room_client_city_id,
                governance_room_secretariat_id: profileFilter.governance_room_secretariat_id ? profileFilter.governance_room_secretariat_id : values.governance_room_secretariat_id
              }
            }
          },
          validations: {
            required: true
          },
          columnSize: 12
        },
        {
          name: 'name',
          type: 'text',
          label: 'Nome',
          validations: {
            required: true
          },
          columnSize: 12
        },
        {
          name: 'cpf',
          type: 'CPF',
          label: 'CPF',
          validations: {
            required: true
          },
          columnSize: 12
        },
        {
          label: 'Tipo',
          type: 'select',
          options: [
            {
              label: "Comercial",
              value: "COMERCIAL"
            },
            {
              label: "Residencial",
              value: "RESIDENCIAL"
            }
          ],
          name: 'address_type',
          validations: {
            required: true
          },
          columnSize: 12
        },
        {
          name: 'address',
          type: 'address',
          validations: {
            required: true
          },
          autocomplete: true,
          columnSize: 12
        },
        {
          name: 'login',
          type: 'text',
          label: 'Login',
          validations: {
            required: true,
            login: true
          },
          columnSize: 12
        },
        {
          name: 'password',
          type: 'password',
          label: 'Senha',
          validations: {
            password: true
          },
          columnSize: 12
        },
        {
          name: 'password_confirm',
          type: 'password',
          label: 'Repetir senha',
          validations: {
            password_confirm: true
          },
          columnSize: 12
        },
        {
          name: 'birth_date',
          type: 'date',
          label: 'Data de Nascimento',
          columnSize: 12,
          validations: {
            required: false
          },
        },
        {
          name: 'rg',
          type: 'RG',
          label: 'RG',
          validations: {
            required: false
          },
          columnSize: 12
        },
        {
          name: 'social_name',
          type: 'text',
          label: 'Nome Social',
          validations: {
            required: false
          },
          columnSize: 6
        },
        {
          name: 'gender',
          type: 'select',
          label: 'Gênero',
          options: [
            { label: 'Masculino', value: 'M' },
            { label: 'Feminino', value: 'F' },
            { label: 'Não Identificar', value: 'NI' },
            { label: 'Ignorado', value: 'I' },
          ],
          validations: {
            required: false
          },
          columnSize: 6
        },
        {
          name: 'phones',
          type: 'multiinput',
          label: 'Contatos',
          sortBy: 'index',
          form: [
            {
              label: 'Tipo',
              type: 'select',
              options: [{
                label: "Tel. Institucional",
                value: "TELINSTITUCIONAL"
              },
              {
                label: "Tel. Fixo",
                value: "TELFIXO"
              },
              {
                label: "Recado",
                value: "RECADO"
              },
              {
                label: "Comercial",
                value: "COMERCIAL"
              },
              {
                label: "Residencial",
                value: "RESIDENCIAL"
              },
              {
                label: "Celular",
                value: "CELULAR"
              }],
              name: 'type',
              validations: {
                required: true
              }
            },
            {
              label: 'Telefone',
              type: 'phone',
              name: 'phone',
              validations: {
                required: true
              }
            }
          ],
          validations: {
            required: true
          },
          columnSize: 12
        },
        {
          name: 'emails',
          type: 'multiinput',
          label: 'Emails',
          sortBy: 'index',
          form: [
            {
              label: 'Tipo',
              type: 'select',
              options: [{
                label: "Institucional",
                value: "INSTITUCIONAL"
              },
              {
                label: "Pessoal",
                value: "PESSOAL"
              },
              {
                label: "Comercial",
                value: "COMERCIAL"
              }],
              name: 'type',
              validations: {
                required: true
              }
            },
            {
              label: 'Email',
              type: 'email',
              name: 'email',
              maxLength: 100,
              validations: {
                required: true
              }
            }
          ],
          validations: {
            required: true
          },
          columnSize: 12
        },
        {
          name: 'status',
          type: 'select',
          label: 'Status',
          options: [
            { label: 'Ativo', value: '1' },
            { label: 'Bloqueado', value: '0' },
          ],
          validations: {
            required: true
          },
          columnSize: 12
        },
      ],
      customValidators: {
        password_confirm: (value, options, key, attributes) => {
          if (attributes.password) {
            if (attributes.password != attributes.password_confirm) {

              return '^O campo repetir senha deve ter igual ao campo senha';
            }
          }
          return '';
        },
        login: async (value, options, key, attributes) => {
          const checkLogin = async (value) => {
            let post = { login: value };
            post.user_id = id;
            if (value.trim().length > 2) {
              let response = await Fetch.post(config.endpoints.backend + 'core/users/getbylogin', post);
              if (response.id) {
                return '^O login já está sendo utilizado por outro usuário';
              }
            }

            return "";
          }
          return checkLogin(value);
        },
        validateEmail: async (value) => {
          const checkEmail = async (value) => {
            let response = await Fetch.post(config.endpoints.backend + 'core/users/getByEmail', { email: value, id: id });

            if (response.id) {
              return '^O e-mail já está sendo utilizado por outro usuário';
            }
            return "";
          }
          return checkEmail(value);
        }
      },
      ...paths,
      ...labels
    }
    form.values = values;
    return form;
  }
  useEffect(() => {
    const load = async () => {
      let values = {};

      if (id) {
        values = await Fetch.post(paths.endpointGetById, { id });
      }
      if (sessionSelector.governance_room_client_city_id) {
        values.governance_room_client_city_id = sessionSelector.governance_room_client_city_id;

        dispatch({ type: 'UPDATE_SESSION', key: 'governance_room_client_city_id', value: null });
      }
      const form = getForm(values);
      setForm(form);
      setFormContent(
        <div>
          <CustomFormContainer
            form={form}
            content={<CustomForm form={form} />}
          />
        </div>
      );
      setActiveTab("form");
    }
    load();
  }, [])

  return (
    <div>
      {formContent}
    </div>
  );
}
export default Form;
